import React from 'react';
import styled from 'styled-components';
import paypointLogo from '../../assets/images/paypoint-logo.png';

const Branding = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: ${(props) => props.$marginTop || '24px'};
  margin-bottom: ${(props) => props.$marginBottom || '0'};
  padding-top: ${(props) => props.$paddingTop || '0'};
  border-top: ${(props) => (props.$showDivider ? '1px solid #e2e8f0' : 'none')};
`;

const BrandingText = styled.p`
  margin: 0;
  color: #64748b;
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
`;

const Logo = styled.img`
  height: ${(props) => props.$height || '48px'};
  width: auto;
  object-fit: contain;
`;

const PayPointBranding = ({
  showDivider = true,
  marginTop,
  marginBottom,
  paddingTop = '20px',
  logoHeight = '48px',
  className
}) => (
  <Branding
    className={className}
    $showDivider={showDivider}
    $marginTop={marginTop}
    $marginBottom={marginBottom}
    $paddingTop={paddingTop}
  >
    <BrandingText>Payments Powered by PayPoint</BrandingText>
    <Logo src={paypointLogo} alt="PayPoint" $height={logoHeight} />
  </Branding>
);

export default PayPointBranding;
